<template>
    <div class="modal-wrapper" :class="{hide: !modals.withdrawalPolicy}" v-on:click.stop="hideModal">
        <div class="modal" v-on:click.stop>
            <div class="title">
                Withdrawal Policy
                <i class="material-icons pointer" @click="hideModal">close</i>
            </div>
            <div class="row">
                <span>
                    The Company finance department supervises every withdrawal request submitted. We will process withdrawals within the first 30 days of an account being opened, although special requests may be considered. Please e-mail support@aydopro.com with such requests.
                </span>
                <span>
                    To be eligible to make a withdrawal, you must first supply full compliance documentation (Passport copy, valid utility bill, and, in some cases, a copy of the credit card used to make the deposits). The minimum withdrawal amount is $50 by credit card or its equivalent in your chosen fiat currency. There is no fee for withdrawal by credit card.
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import {MODAL} from '@/store/mutations.type'

export default {
    name: "WithdrawalPolicyModal",
    methods: {
        hideModal() {
            this.$store.commit(MODAL, {
                withdrawalPolicy: false
            })
        },
    },
    computed: {
        ...mapGetters(['modals']),
    }
}
</script>

<style scoped>
.modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: var(--background-dark);
    padding: 25px;
    border: 1px solid var(--border);
    z-index: 1100;
}

.title {
    color: var(--white-to-black);
    font-weight: 600;
    font-size: 1.5em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.title i {
    font-size: 20px;
}

.row {
    overflow: hidden;
    align-items: stretch;
    flex-wrap: nowrap;
    font-size: 1.3em;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    gap: 20px;
}
</style>